// extracted by mini-css-extract-plugin
export var box = "_49-1";
export var checked = "_49-2";
export var descriptionSpacer = "_49-9";
export var disabled = "_49-3";
export var icon = "_49-6";
export var input = "_49-0";
export var labelSpacer = "_49-8";
export var medium = "_49-5";
export var small = "_49-4";
export var text = "_49-7";